module.exports = __webpack_public_path__ + "img/Group 5@2x.39dae614.png";